import { useState } from "react";

import type { MerryButtonInteractionState } from "@/shared/ui/merryButtonVariants";

interface MerryButtonInteractionOptions {
  isDisabled?: boolean;
  onHoverChange?: (isHovered: boolean) => void;
  onPressChange?: (isPressed: boolean) => void;
}

export function useMerryButtonInteractionState({
  isDisabled = false,
  onHoverChange,
  onPressChange,
}: MerryButtonInteractionOptions = {}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const interactionState: MerryButtonInteractionState = isDisabled
    ? "default"
    : isPressed
      ? "pressed"
      : isHovered
        ? "hovered"
        : "default";

  return {
    interactionState,
    onHoverChange: (nextIsHovered: boolean) => {
      setIsHovered(nextIsHovered);
      onHoverChange?.(nextIsHovered);
    },
    onPressChange: (nextIsPressed: boolean) => {
      setIsPressed(nextIsPressed);
      onPressChange?.(nextIsPressed);
    },
  };
}
